import { SVGProps, Ref, forwardRef } from 'react';

export const ShieldOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 21.151c-1.837-.498-3.806-2.019-5.048-3.714C5.644 15.649 4.8 13.563 4.8 11V5.297l7.2-2.4 7.2 2.4V11c0 2.569-.86 4.699-2.144 6.425-1.243 1.67-3.227 3.225-5.057 3.726M21 4l-9-3-9 3v7c0 3 1 5.451 2.5 7.5s4 4 6.5 4.5c2.5-.5 5.012-2.5 6.5-4.5S21 14 21 11z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ShieldOutlinedSize24Glyph.displayName = 'ShieldOutlinedSize24Glyph';
